import "$styles/index.scss"
import "./controllers"

import Collapse from "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/offcanvas"
import "bootstrap/js/dist/modal"

// Keep accordion behavior predictable and allow closing an already-open item.
document.addEventListener('DOMContentLoaded', () => {
  // Bootstrap's data-api handler can run before bubble listeners.
  // Use capture + stopImmediatePropagation so a second click on an open item actually closes it.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.accordion-button')
    if (!button) return

    const targetSelector = button.getAttribute('data-bs-target') || button.getAttribute('data-target')
    if (!targetSelector) return

    const target = document.querySelector(targetSelector)
    if (!target || !target.classList.contains('show')) return

    event.preventDefault()
    event.stopImmediatePropagation()

    const instance = Collapse.getOrCreateInstance(target, { toggle: false })
    instance.hide()
  }, true)
})

// Safari has done its job and tinted the top bar. Now we can hide the element.
window.addEventListener('load', () => {
  document.querySelectorAll('.safari-tint-bar').forEach(bar => {
    bar.style.marginTop = `-1px`
    bar.style.height = `0`
  })
})
